/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonalInformationRequest
 */
export interface PersonalInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof PersonalInformationRequest
     */
    gender?: PersonalInformationRequestGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof PersonalInformationRequest
     */
    birthDate?: Date;
}


/**
 * @export
 */
export const PersonalInformationRequestGenderEnum = {
    Undefined: 'UNDEFINED',
    Man: 'MAN',
    Woman: 'WOMAN',
    Other: 'OTHER'
} as const;
export type PersonalInformationRequestGenderEnum = typeof PersonalInformationRequestGenderEnum[keyof typeof PersonalInformationRequestGenderEnum];


/**
 * Check if a given object implements the PersonalInformationRequest interface.
 */
export function instanceOfPersonalInformationRequest(value: object): value is PersonalInformationRequest {
    return true;
}

export function PersonalInformationRequestFromJSON(json: any): PersonalInformationRequest {
    return PersonalInformationRequestFromJSONTyped(json, false);
}

export function PersonalInformationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalInformationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
    };
}

export function PersonalInformationRequestToJSON(value?: PersonalInformationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'gender': value['gender'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate']).toISOString().substring(0,10)),
    };
}

